const Map = () => import(/* webpackChunkName: "Transport" */ "@/views/map/Map");

const interactiveMapRoutes = [
  {
    path: "interactiveMap",
    name: "Interactive Map",
    redirect: {
      name: "Map Upload"
    },
    component: Map,
    children: [
      {
        path: "preview",
        name: "Map Preview",
        component: () =>
          import(
            /* webpackChunkName: "surveys" */ "../../views/map/MapPreview.vue"
          )
      },
      {
        path: "upload",
        name: "Map Upload",
        component: () =>
          import(
            /* webpackChunkName: "surveys" */ "../../views/map/MapUpload.vue"
          )
      }
    ]
  }
];

export default interactiveMapRoutes;
